import React, { createContext, useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

const WishlistContext = createContext();

export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const [anonymousId, setAnonymousId] = useState(null);

  useEffect(() => {
    let id = Cookies.get('wishlistAnonymousId');
    if (!id) {
      id = uuidv4();
      Cookies.set('wishlistAnonymousId', id, { expires: 7 });
    }
    setAnonymousId(id);

    const loadWishlistItems = async () => {
      const savedWishlistItems = Cookies.get(id);
      if (savedWishlistItems) {
        try {
          const parsedItems = JSON.parse(savedWishlistItems);
          
          const productIds = parsedItems.map(item => item.id);
          const products = await fetchProductsByIds(productIds);
          
          setWishlistItems(products || []);
        } catch (error) {
          console.error('Error loading wishlist items:', error);
        }
      }
    };

    if (id) loadWishlistItems();
  }, []);

  const fetchProductsByIds = async (ids) => {
    const productIds = ids.map(item => (typeof item === 'object' ? item.id : item));
  
  
    try {
      const productPromises = productIds.map(id => 
        axios.get(`https://api.theonlysale.com/api/product/get/${id}`)
      );
  
      const responses = await Promise.all(productPromises);
  
      const products = responses.map(response => {
        const productData = response.data;
  
        let imagesArray = [];
        if (productData.images) {
          try {
            imagesArray = JSON.parse(productData.images);
          } catch (e) {
            console.error("Error parsing images array:", e);
          }
        }
  
        const imageURIs = imagesArray.map(image =>
          `https://api.theonlysale.com/uploads/images/${image.split(/[\\/]/).pop()}`
        );
  
        return { ...productData, imageURIs };
      });
  
      return products;
    } catch (error) {
      console.error('Error fetching product details:', error);
      return [];
    }
  };
  
  
  

  useEffect(() => {
    if (anonymousId) {
      const wishlistItemsToSave = wishlistItems.map(item => ({ id: item.id }));
      Cookies.set(anonymousId, JSON.stringify(wishlistItemsToSave), { expires: 7 });
    }
  }, [wishlistItems, anonymousId]);

  const addToWishlist = async (itemId) => {
    const isItemInWishlist = wishlistItems.find(existingItem => existingItem.id === itemId);
    
    if (!isItemInWishlist) {
      try {
        const product = await fetchProductsByIds([itemId]); 
        if (product.length > 0) {
          setWishlistItems((prevItems) => [...prevItems, product[0]]);
        }
      } catch (error) {
        console.error('Error adding item to wishlist:', error);
      }
    } else {
      console.log('Item is already in the wishlist');
    }
  };
  
  const removeFromWishlist = (productIdToRemove) => {
    const updatedWishlist = wishlistItems.filter(item => item.id !== productIdToRemove);
    setWishlistItems(updatedWishlist);
  };

  const contextValue = {
    wishlistItems,
    addToWishlist,
    removeFromWishlist,
  };

  return (
    <WishlistContext.Provider value={contextValue}>
      {children}
    </WishlistContext.Provider>
  );
};
